import { useTranslation } from 'react-i18next';

import { formatBasedOnSortArray } from 'support/helpers/arrays/arrays';
import { DOCUMENT_TYPE_ORDER } from 'support/helpers/const/const';
import { ConnectionPartner, ConnectionRelationship, DocumentType } from 'support/types';

import { RelationshipBadge } from '../RelationshipBadge/RelationshipBadge';

export const DocumentTypeBadges = ({
  currentPartnerId,
  otherPartner,
}: {
  currentPartnerId: string;
  otherPartner: ConnectionPartner;
}) => {
  const { t } = useTranslation();
  const allRelationships: Array<ConnectionRelationship> = [
    ...(otherPartner?.receiver_relationships || []),
    ...(otherPartner?.sender_relationships || []),
  ].sort(
    formatBasedOnSortArray(DOCUMENT_TYPE_ORDER, (array, value) => array.indexOf(value.message_type as DocumentType)),
  );
  return (
    <div className="flex flex-wrap gap-1 text-sm text-gray-900">
      {allRelationships?.map((relationship) => (
        <RelationshipBadge key={relationship.id} relationship={relationship} currentPartnerId={currentPartnerId}>
          {t(`common:messageTypes.plural.${relationship.message_type}`)}
        </RelationshipBadge>
      ))}
    </div>
  );
};
